import Login from "./pages/Login";
import LoginText from "./pages/Login/LoginText";
import RegisterFirst from "./pages/Register/RegisterFirst";
import RegisterSecond from "./pages/Register/RegisterSecond";
import RegisterFinal from "./pages/Register/RegisterFinal";
import Authorize from "./pages/Authorize";
import ResetPassword from "./pages/ResetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import Recommend from "./pages/Recommend";
import {
  getFirstRegisterValue,
  getSecondRegisterValue,
} from "./pages/Dashboard/Dashboard";

const routes = [
  {
    path: "/",
    element: <div>error</div>,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/login/text",
    element: <LoginText />,
  },
  {
    path: "/registerFirst",
    element: <RegisterFirst sendValue={getFirstRegisterValue} />,
  },
  {
    path: "/registerSecond",
    element: <RegisterSecond sendValue={getSecondRegisterValue} />,
  },
  {
    path: "/registerFinal",
    element: <RegisterFinal />,
  },
  {
    path: "/resetPassword",
    element: <ResetPassword />,
  },
  {
    path: "/forgotPassword",
    element: <ForgotPassword />,
  },
  {
    path: "/authorize",
    element: <Authorize />,
  },
  {
    path: "/Recommend",
    element: <Recommend />,
  },
];
export default routes;
